import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  CircularProgress,
  Box,
  Typography,
  makeStyles,
  Theme,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useAttachments } from "../../../../common/CommonQueries";
import DescriptionIcon from '@material-ui/icons/DescriptionOutlined';

const useStyles = makeStyles((theme: Theme) => ({
  actionButton: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    textTransform: "none",
    color: "#475569",
    fontSize: "0.85rem",
    fontWeight: 600,
    padding: "8px 14px",
    justifyContent: "center",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#f8fafc",
      borderColor: "#cbd5e1",
      color: "#1e293b",
    },
  },
  buttonIcon: {
    fontSize: 14,
    color: "#4A545F",
  },
  badgeCount: {
    backgroundColor: "#e08c00",
    color: "#ffffff",
    fontSize: "10px",
    fontWeight: 600,
    borderRadius: 10,
    padding: "1px 7px",
    marginLeft: theme.spacing(1),
  },
  fileItem: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    marginBottom: theme.spacing(1),
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#f8fafc",
    },
  },
  fileIcon: {
    color: "#e08c00",
  },
}));



export const ViewAttachmentsModal = ({
  files = [],
  
}:any) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  
  const {
      data: attachments,
      isLoading: isLoadingAttachments,
      isError: isErrorAttachments,
      isSuccess: isSuccessAttachments,
      error: errorAttachments,
    } = useAttachments(files);
    const totalAttachments = attachments?.length || 0;

  return (
    <>
      {/* Trigger Button */}
      <Button
        variant="outlined"
        startIcon={<DescriptionIcon className={classes.buttonIcon} />}
        onClick={() => setOpen(true)}
        style={{height:29}}
        fullWidth
        className={classes.actionButton}
        disableElevation
        disabled={isLoadingAttachments}
      >
        {isLoadingAttachments ? (
          <CircularProgress size={16} />
        ) : (
          <>
           <span style={{fontSize:"12px",color:"#4A545F"}}>View Attachments</span> 
            
          </>
        )}
      </Button>

      {/* Attachments Listing Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent style={{ padding: "20px 24px" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              Attached Files ({totalAttachments})
            </Typography>
            <IconButton size="small" onClick={() => setOpen(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {totalAttachments === 0 ? (
            <Box py={4} textAlign="center" color="text.secondary">
              <Typography variant="body2">No attachments found for this note.</Typography>
            </Box>
          ) : (
            <List disablePadding>
              {attachments.map((file: any, idx: number) => (
                <ListItem key={file.id || idx} className={classes.fileItem}>
                  <ListItemIcon>
                    <InsertDriveFileIcon className={classes.fileIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={file.name || file.filename || `Attachment ${idx + 1}`}
                    secondary={file.created_at || file.size || "Server File"}
                    primaryTypographyProps={{ style: { fontWeight: 500, fontSize: "0.9rem" } }}
                  />
                  <ListItemSecondaryAction>
                    {file.url && (
                      <IconButton
                        edge="end"
                        component="a"
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                      >
                        <GetAppIcon fontSize="small" />
                      </IconButton>
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button onClick={() => setOpen(false)} color="primary" style={{ fontWeight: 600 }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};